<template>
  <div style="min-width: 60px">
    <ul v-if="Array.isArray(content)">
      <li v-for="(li, i) in content" :key="li + i" class="">
        <vue-markdown class="mdContent" :key="'listContentMD_' + i">{{
          li
        }}</vue-markdown>
      </li>
    </ul>
    <div v-else class="">
      <vue-markdown class="mdContent" :key="content">{{
        content
      }}</vue-markdown>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";
import VueMarkdown from "@adapttive/vue-markdown";

export default {
  name: "ListOrText",
  components: { VueMarkdown },
  props: {
    content: null,
    contentType: {
      type: String,
      default: "html", // todo - add option to choose and display "markdown"
    },
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
